jQuery(document).ready(function($){

    $('.social-media-share').jsSocials({
        showLabel: false,
        text: $('.small-banner h1').text(),
        showLabel: true,
        shares:[{
            share: 'facebook',
            logo: 'fab fa-facebook',
            label: '<span class="sr-only">Facebook</span>'
        }, {
            share: 'twitter',
            logo: 'fab fa-twitter-square',
            label: '<span class="sr-only">Twitter</span>'

        }, {
            share: 'linkedin',
            logo: 'fab fa-linkedin',
            label: '<span class="sr-only">LinkedIn</span>'

        }
    ]
    });
});